import { Box, BoxProps, CircularProgress } from "@mui/material";

const LoadingSpinner = ({ ...props }: BoxProps) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="100vh"
    {...props}
  >
    <CircularProgress />
  </Box>
);

export default LoadingSpinner;
